import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import AOS from 'aos';

import 'element-ui/lib/theme-chalk/index.css';
import 'aos/dist/aos.css';

import '@/css/reset.css'
import '@/assets/iconfont/iconfont.css'


Vue.use(ElementUI);
Vue.use(AOS);

Vue.config.productionTip = false;
Vue.prototype.$navIndex = '1';
AOS.init({
    offset:200,
    duration:800,
    once:false
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')